import { render, staticRenderFns } from "./embed-store.vue?vue&type=template&id=332d8b32&scoped=true&"
import script from "./embed-store.vue?vue&type=script&lang=js&"
export * from "./embed-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332d8b32",
  null
  
)

export default component.exports